export const TEST_ID = 'staleSyncBanner';

export const LAST_SYNC_LABEL = '2 min ago';
